import Home from "../views/Home";
import stoneRouter from './stone'
// import stoneDetailRouter from './stone_detail'
import usersRouter from './user'
import exceptionRouter from './exeption'
const HomeRouter = {
  path: "/",
  name: "Home",
  component: Home,
  meta: {
    requiresAuth: false,
  },
  children: [],
};

HomeRouter.children.push(stoneRouter);
// HomeRouter.children.push(stoneDetailRouter);
HomeRouter.children.push(usersRouter);
HomeRouter.children.push(exceptionRouter);


export default HomeRouter;
